export default __webpack_public_path__ + "static/media/browser-opera.d6ebb0cc.svg";